/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EpexCompleteDto } from './epexCompleteDto';
import { PurpleApiResponseStatus } from './purpleApiResponseStatus';


export interface EpexCompleteDtoPurpleApiResponse { 
    status: PurpleApiResponseStatus;
    calledController?: string | null;
    calledMethod?: string | null;
    message: string;
    exitCode: number;
    data?: EpexCompleteDto;
}
export namespace EpexCompleteDtoPurpleApiResponse {
}


